function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "prefix__Grupo_440",
  "data-name": "Grupo 440"
}, React.createElement("path", {
  id: "prefix__Trazado_1127",
  d: "M1135.443 115.23c10.076 0 16.919 5.941 16.919 15.716 0 10.6-7.519 15.265-17.6 15.265l-.3 5.94h-7.444l-.376-11.806h2.481c8.5 0 15.039-1.5 15.039-9.4 0-5.263-3.233-8.5-8.647-8.5-5.339 0-8.722 3.008-8.722 8.271h-8.046c-.072-9.094 6.47-15.486 16.696-15.486zm-4.812 53.54a5.49 5.49 0 115.414-5.49 5.425 5.425 0 01-5.414 5.49z",
  "data-name": "Trazado 1127"
}));

var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 101.818,
    height: 101.818,
    viewBox: "0 0 101.818 101.818",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    id: "prefix__Grupo_441",
    "data-name": "Grupo 441",
    transform: "translate(-1081.091 -91.091)"
  }, _ref2, React.createElement("circle", {
    id: "prefix__Elipse_120",
    cx: 48,
    cy: 48,
    r: 48,
    "data-name": "Elipse 120",
    transform: "translate(1084 94)",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: "5.818px"
    }
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.9a4e0f2d.svg";
export { ForwardRef as ReactComponent };